import React, { useState } from 'react';
import AutoComplete from 'material-ui/AutoComplete';
import RaisedButton from 'material-ui/RaisedButton';
import Paper from 'material-ui/Paper';
import api from 'services';
import helpers from 'helpers';

import './LoginAsPage.scss';
import { useRefState } from 'helpers/react.utils';
import IdsConverter from './IdsManipulators/IdsConverter';
import IdsEntities from './IdsManipulators/IdsEntities';

function loadUserInfo(emailLike) {
    if (emailLike.length < 3) {
        return [];
    }
    return api.findUser(emailLike).then(response => response.data.data).catch((err) => {
        console.error(err);
        return null;
    });
}

async function copyToClipboard(userId) {
    const session = await helpers.prepareOneTimeAuthSession(userId);

    const link = `${VARS.platformUrl}/api/v1/auth/loginAs?key=${session.key}`;

    console.log(link);

    navigator.clipboard.writeText(link);
}

async function loginInNewPage(userId) {
    const session = await helpers.prepareOneTimeAuthSession(userId);

    const link = `${VARS.platformUrl}/api/v1/auth/loginAs?key=${session.key}`;

    const form = document.createElement('form');
    form.method = 'POST';
    form.action = link;
    form.target = '_blank';

    document.body.appendChild(form);

    form.submit();
    form.remove();
}

/**
 * @param {{ customCompanyName?: string }} props
 */
export function LoginAsPage({ customCompanyName }) {
    const [search, setSearch, searchRef] = useRefState('');
    const [emails, setResults] = useState([]);
    const [user, setUser] = useState(null);

    async function searchUsers(searchText) {
        setSearch(searchText);

        let _emails = await loadUserInfo(searchText);

        if (searchRef.current !== searchText) {
            return;
        }

        if (Array.isArray(_emails) && customCompanyName) {
            _emails = _emails
                .filter(e => e.company.name && new RegExp(customCompanyName, 'i').test(e.company.name));
        }

        setResults(_emails);
    }

    function onUserSelected(_user) {
        setSearch('');
        setUser(_user);
    }

    return (
        <div className="login-as-page">
            <Paper style={{ padding: '20px' }} zDepth={2} rounded={false} className="wrapper">
                <h3>This block allows to log in as specific user</h3>

                <div className="notes">
                    <p>Security considerations:</p>
                    <ul>
                        <li>admin rights (only specific devs can use);</li>
                        <li>auth link valid for one day;</li>
                        <li>authorization lasts for the session time;</li>
                        <li>link invalidates after first usage (aka one time auth link);</li>
                    </ul>
                </div>

                <p className="">User email:</p>
                
                <AutoComplete
                    name="userEmail"
                    textFieldStyle={{ fontSize: '13px' }}
                    hintText="User email or id"
                    searchText={search}
                    dataSource={emails || []}
                    dataSourceConfig={{ text: 'email', value: 'item' }}
                    onUpdateInput={searchUsers}
                    onNewRequest={onUserSelected}
                    filter={AutoComplete.noFilter}
                    listStyle={{ overflow: 'auto', maxHeight: '300px' }}
                    popoverProps={{
                        canAutoPosition: true,
                    }}
                    fullWidth
                />
                {
                    user ? (
                        <React.Fragment>
                            <div className="line">
                                Selected user:
                                <br />
                                {user.email} ({user.company && user.company.name})
                            </div>
                            <div className="buttons">
                                <div className="">
                                    <RaisedButton label="Copy auth link" primary onClick={() => copyToClipboard(user._id)} />
                                </div>
                                <div className="">
                                    <RaisedButton label="Login in new page" secondary onClick={() => loginInNewPage(user._id)} />
                                </div>
                            </div>
                        </React.Fragment>
                    ) : null
                }
            </Paper>
            <div className='ids-manipulators'>
                <IdsConverter />
                <IdsEntities />
            </div>
        </div>
    );
}



// WEBPACK FOOTER //
// ./app/components/LoginAsPage/LoginAsPage.jsx